var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9596C5.05835 18.9596 1.04169 14.943 1.04169 10.0013C1.04169 5.05964 5.05835 1.04297 10 1.04297C14.9417 1.04297 18.9584 5.05964 18.9584 10.0013C18.9584 14.943 14.9417 18.9596 10 18.9596ZM10 2.29297C5.75002 2.29297 2.29169 5.7513 2.29169 10.0013C2.29169 14.2513 5.75002 17.7096 10 17.7096C14.25 17.7096 17.7084 14.2513 17.7084 10.0013C17.7084 5.7513 14.25 2.29297 10 2.29297Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99987 11.4638C9.6582 11.4638 9.37487 11.1805 9.37487 10.8388V10.6638C9.37487 9.69717 10.0832 9.22216 10.3499 9.03883C10.6582 8.8305 10.7582 8.68884 10.7582 8.47217C10.7582 8.0555 10.4165 7.71381 9.99987 7.71381C9.5832 7.71381 9.24156 8.0555 9.24156 8.47217C9.24156 8.81384 8.95822 9.09717 8.61656 9.09717C8.27489 9.09717 7.99156 8.81384 7.99156 8.47217C7.99156 7.36383 8.89153 6.46381 9.99987 6.46381C11.1082 6.46381 12.0082 7.36383 12.0082 8.47217C12.0082 9.42217 11.3082 9.89715 11.0499 10.0722C10.7249 10.2888 10.6249 10.4305 10.6249 10.6638V10.8388C10.6249 11.1888 10.3415 11.4638 9.99987 11.4638Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5388C9.65002 13.5388 9.37502 13.2555 9.37502 12.9138C9.37502 12.5721 9.65835 12.2888 10 12.2888C10.3417 12.2888 10.625 12.5721 10.625 12.9138C10.625 13.2555 10.35 13.5388 10 13.5388Z",
    fill: "#026C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.fbe6d79a2a2715efaa925a38ab920718.svg";
export { ForwardRef as ReactComponent };